import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TokenHandlerService } from '@celerofinancas/ui-oauth';
import { TokenAuthenticationEvents } from '@shared/models/token-authentication-events';
import { map, startWith } from 'rxjs';

/**
 * Guard for validating authentication status and handling navigation accordingly
 */
export const authValidationGuard: CanActivateFn = (route) => {
  const tokens = inject(TokenHandlerService);
  const router = inject(Router);

  return tokens.eventsSubject$.pipe(
    startWith({ event: null }),
    map((event) => {
      const hasIdToken = route.queryParams?.idToken;
      const isTokenValid = tokens.isRefreshTokenValid && tokens.accessToken;
      const hasAuthFailed = event?.event === TokenAuthenticationEvents.TOKEN_EXCHANGED_FAILED;

      if (!hasAuthFailed && (hasIdToken || !isTokenValid)) {
        const backUrl = route.url.map((segment) => segment.path).join('/');

        router.navigate(['/validation'], {
          queryParams: { ...route.queryParams, backUrl },
        });
        return false;
      }

      // TODO: Implement this route later
      // if (hasAuthFailed) {
      //   router.navigate(['/error']);
      //   return false;
      // }

      return true;
    }),
  );
};
